import { PRO_SUBSCRIPTION } from "@/constants";
import { PricingSelector } from "@/features/Subscriptions/components/Pricing/PricingSelector";
import { goto_manage_subscription_event } from "@/services/posthog/events";
import { useAnalytics } from "@/services/posthog/hooks";
import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  useToast,
} from "@chakra-ui/react";
import { useState } from "react";
import { goToBillingPortal } from "../../../Checkout/actions/goToBillingPortal";
import { useSubscription } from "../../hooks/useSubscription";

interface SubscriptionPanelProps {
  isOpen: boolean;
  onClose: () => void;
}

const proPlanTitle = "Pro plan";
const freePlanTitle = "Free plan";
const proPlanDescription = "You can manage your subscription details by clicking on Manage Payments.";
const freePlanDescription = "Upgrade to unlock more features.";

export const SubscriptionPanel = (props: SubscriptionPanelProps) => {
  const { isOpen, onClose } = props;
  const { data: subscription } = useSubscription();
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();
  const analytics = useAnalytics();

  const hasProSubscription = subscription?.type === PRO_SUBSCRIPTION;

  return (
    <Modal
      scrollBehavior={"inside"}
      variant="large"
      closeOnOverlayClick={false}
      isOpen={isOpen}
      onClose={onClose}
      size="2xl"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader padding="spacing-lg">
          <Text textStyle="heading/2">Manage subscriptions</Text>
          <ModalCloseButton mt="4px" />
        </ModalHeader>
        <ModalBody>
          <Stack gap="spacing-xl">
            <Text textStyle="label/L/medium">Current plan</Text>
            <Flex justifyContent="space-between" alignItems="center">
              <Stack gap="spacing-sm">
                <Text textStyle="label/M/medium">{hasProSubscription ? proPlanTitle : freePlanTitle}</Text>
                <Text textStyle="label/S/regular" color="foreground.secondary">
                  {hasProSubscription ? proPlanDescription : freePlanDescription}
                </Text>
              </Stack>
              <Button
                isLoading={isLoading}
                onClick={async () => {
                  setIsLoading(true);
                  analytics.capture(goto_manage_subscription_event, { from: "user_menu" });
                  const { error } = await goToBillingPortal();
                  if (error) {
                    toast({
                      title: "Error",
                      description: "An error occurred while processing your request. Please try again later.",
                      status: "error",
                      position: "top",
                    });
                  }
                  setIsLoading(false);
                }}
              >
                Manage Payments
              </Button>
            </Flex>
            <Text textStyle="label/L/medium">All plans</Text>
            <Stack gap="spacing-xs">
              <PricingSelector onContactSales={onClose} />
            </Stack>
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
